"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipIcon = exports.ToolTipBody = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tooltip_info_icon = _interopRequireDefault(require("./assets/tooltip_info_icon.svg"));

var _tooltip_info_icon_pink = _interopRequireDefault(require("./assets/tooltip_info_icon_pink.svg"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ToolTipBody = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  color: #858585;\n  box-shadow:  0px 5px 20px rgba(0, 0, 0, 0.1);\n  background: #FFFFFF;\n  font-size: 12px;\n  padding: 30px;\n  border-radius: 15px;\n  z-index: 2;\n  border-top-left-radius: 0;\n\n  ", ";\n"])), function (_ref) {
  var style = _ref.style;
  return style;
});

exports.ToolTipBody = ToolTipBody;

var TooltipIcon = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 20px;\n  width: 20px;\n  background: url(", ") center no-repeat;\n  background-size: ", ";\n  position: relative;\n  top: -1px;\n  padding-left: 6px;\n\n  &:hover {\n    background-image: url(", ") center no-repeat\n  }\n"])), function (_ref2) {
  var icon = _ref2.icon;
  return icon ? icon : _tooltip_info_icon["default"];
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return iconSize === 'small' ? '9px' : '12px';
}, function (_ref4) {
  var icon = _ref4.icon;
  return icon ? icon : _tooltip_info_icon_pink["default"];
});

exports.TooltipIcon = TooltipIcon;

//# sourceMappingURL=styled.js.map